<template>
  <div class="user-wrapper">
    <van-cell-group>
      <van-cell
        v-for="(item, index) of links"
        center
        is-link
        size="large"
        :key="index"
        :title="item.title"
        :to="item.path"
        @click="onShow(item)"
      >
        <template v-slot:icon>
          <van-icon size="20" class="icon" :name="item.icon" :color="item.color" />
        </template>
      </van-cell>
    </van-cell-group>

    <van-cell-group v-if="is_distribution">
      <van-cell
        v-for="(item, index) of links2"
        center
        is-link
        size="large"
        :key="index"
        :title="item.title"
        :to="item.path"
        @click="onShow(item)"
      >
        <template v-slot:icon>
          <van-icon size="20" class="icon" :name="item.icon" :color="item.color" />
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  props: {
    is_distribution: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      links: [
        {
          icon: 'qr',
          color: '#6FB5FF',
          title: '付款码',
          type: 1,
        },
      ],
      links2: [
        {
          icon: 'qr',
          color: '#eee081',
          title: '分销二维码',
          type: 2,
        },
        {
          icon: 'warning-o',
          color: '#f38181',
          title: '分销说明',
          path: '/venue_member_explain',
        },
        {
          icon: 'down',
          color: '#fcc38a',
          title: '下级会员',
          path: '/venue_member_subordinate',
        },
        {
          icon: 'refund-o',
          color: '#ea8fd0',
          title: '返佣记录',
          path: '/venue_member_rebate',
        },
        {
          icon: 'cash-back-record',
          color: '#95b1d3',
          title: '返佣提现',
          path: '/venue_member_extract',
        },
      ],
    };
  },
  methods: {
    onShow(item) {
      this.$emit('show', item);
    },
  },
};
</script>

<style lang="less" scoped>
.user-wrapper {
  .icon {
    margin-right: 8px;
  }
}
</style>
